<template>
  <div class="animated fadeIn">
    <div class="row mb-20">
      <div class="col-12">
        <div class="font-bold mb-10">Keysoft History</div>
        <div class="box-mini mb-10">
          <div class="p-15 pb-0">
            <div class="row">
              <div class="col-sm-7"></div>
              <div class="col-sm-5 text-right">
                <div class="search-header">
                  <div class="custom-search-container">
                    <div class="input-group custom-search">
                      <input
                        type="text"
                        @keyup.enter="enterClicked(searchData)"
                        v-model="searchData"
                        class="form-control"
                        placeholder="Search"
                      />
                      <span class="icon-magnifier icon-input-custom"></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr class="mb-0" />
          <div class="p-15">
            <b-table
              @sort-changed="sortingChanged"
              :hover="hover"
              :striped="striped"
              :bordered="bordered"
              :small="small"
              :fixed="fixed"
              responsive
              :items="items"
              :fields="fields"
              class="table-fixedwidth text-center"
            >
              <template v-slot:cell(receipt_date)="data">{{dateFormat(data.item.receipt_date)}}</template>
              <template v-slot:cell(action)="data">
                <b-button
                  size="sm"
                  @click="openPage('/settlement/edit?id=' + data.item.id)"
                  class="btn-table warning mr-5"
                >
                  <i class="fas fa-pen font-12 mr-5"></i>Edit
                </b-button>
                <b-button
                  size="sm"
                  @click="openPage('/settlement/submit?receipt_date=' + data.item.receipt_date)"
                  class="btn-table green"
                >
                  <i class="fas fa-eye font-12 mr-5"></i>Detail
                </b-button>
              </template>
            </b-table>
            <app-pagination
              class="pagination-custom mt-20"
              :current-page="currentPage"
              :total-pages="totalPage"
              @page-changed="pageOneChanged"
              prev-text="Prev"
              next-text="Next"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Callout } from "@coreui/vue";
import axios from "axios";
import { Auth } from "@/api";
import moment from "moment";
import Pagination from "@/views/component/pagination";

export default {
  name: "keysoftHistory",
  components: {
    "app-pagination": Pagination
  },
  props: {
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      fields: [
        {
          key: "keysoft_transaction_type.name",
          label: "Type",
          sortable: false
        },
        {
          key: "customer_service.name",
          label: "CS Name",
          sortable: false
        },
        {
          key: "amount",
          label: "Total",
          sortable: false
        },
        {
          key: "revenue",
          label: "Revenue",
          formatter: (value, key, item) => {
            return 'Rp. ' + parseInt(value).toLocaleString('id-ID', {maximumFractionDigits:0})
          },
          sortable: false
        },
        {
          key: "created_at",
          label: "Submit Date",
          formatter: (value, key, item) => {
            return moment(value).format('DD MMMM YYYY')
          },
          sortable: false
        },
        {
          key: "date",
          label: "Transaction Date",
          formatter: (value, key, item) => {
            return moment(value).format('DD MMMM YYYY')
          },
          sortable: false
        }
      ],
      dateWeek: "",
      items: [],
      sortType: "",
      sortBy: "",
      searchData: "",
      currentPage: 1,
      paginationLimit: 10,
      totalPage: 0
    };
  },
  methods: {
    pageOneChanged(pageNum) {
      this.currentPage = pageNum;
      this.fetchData();
    },
    sortingChanged(event) {
      this.sortBy = event.sortBy;
      if (event.sortDesc === false) {
        this.sortType = "asc";
      } else {
        this.sortType = "desc";
      }
      this.fetchData();
    },
    enterClicked(searchEvent) {
      this.fetchData();
    },
    openPage(event) {
      this.$router.push(event);
    },
    async fetchData() {
      let response = await axios.get('transaction/v1/keysoft_revenue?' + 'page=' + this.currentPage + '&limit=' + this.paginationLimit + '&sorting=' + this.sortBy + '&sorting_type=' + this.sortType + '&keyword=' + this.searchData);
      this.items = response.data.data.rows;
      this.totalPage = response.data.meta.pageCount;
    }
  },
  created() {
    this.fetchData();
  }
};
</script>
